var React = require('react');

function CloseQuotesInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"data-name":"Open Qutoes","d":"M0,75.689q0-8,.133-15.589t.4-13.992q.8-22.919,7.329-34.517T32.782,0l3.2,13.59q-10.394.272-13.326,6.932T19.722,37.576H38.378V75.689Zm54.636,0q0-8,.133-15.589t.4-13.992q.8-22.919,7.329-34.517T87.417,0l3.2,13.59q-10.394.272-13.326,6.932T74.358,37.576H93.014V75.689Z","transform":"translate(93.014 75.689) rotate(180)","fill":"#f6a352","opacity":"0.5"}));
}

CloseQuotesInline.defaultProps = {"width":"93.014","height":"75.689","viewBox":"0 0 93.014 75.689"};

module.exports = CloseQuotesInline;

CloseQuotesInline.default = CloseQuotesInline;
